import { Link } from 'react-router'
import { Button } from '~/components/ui'

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center">
      <div className="space-y-6 pb-32 text-center">
        <h1 className="text-8xl font-bold text-foreground">404</h1>
        <p className="text-2xl text-muted-foreground">Page not found</p>
        <p className="text-muted-foreground">
          The listing or page you're looking for doesn't exist or has been
          moved.
        </p>
        <Button asChild>
          <Link to="/" className="mt-6 inline-block">
            Go Back Home
          </Link>
        </Button>
      </div>
    </div>
  )
}
